export enum TaxiCorporationUnbilledRouteListParamsOrder {
  START_TIME_DESC = "START_TIME_DESC",
  START_TIME_ASC = "START_TIME_ASC",
  HUMAN_ID_ASC = "HUMAN_ID_ASC",
  HUMAN_ID_DESC = "HUMAN_ID_DESC",
  DRIVER_ASC = "DRIVER_ASC",
  DRIVER_DESC = "DRIVER_DESC",
}

type TaxiCorporationUnbilledRouteListParams = {
  taxiCorporationUuid: string;
  limit: number;
  offset: number;
  order?: TaxiCorporationUnbilledRouteListParamsOrder;
  humanId?: string;
  startTimeSince?: string;
  startTimeTo?: string;
  driver?: string;
  client?: string;
  externalId?: string;
  address?: string;
  endAddress?: string;
  midAddress?: string;
  startAddress?: string;
  cargoOrderHumanId?: number;
  fleetPartner?: string;
};

export default TaxiCorporationUnbilledRouteListParams;
